import { useMsal, useIsAuthenticated } from '@azure/msal-react'

export function useAuth() {
  const { instance, accounts, inProgress } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const account = accounts[0] ?? null

  return {
    instance,
    account,
    inProgress,
    isAuthenticated,
  }
}
